import React from 'react';
import PropTypes from 'prop-types';
import Currency from '../../../_utils/tools/currency';
import Select from '../../../_utils/select-wrapper';
import { PrintSize, DeliveryOption } from '../../prop-types';
import Utils from '../../common/size-helpers';
import { QuantityHelpers } from '../../common/quantity-helpers';

class PrintSizeFilter extends React.Component {
  get sizes() {
    const { sizes, generateSizeOptionLabel } = this.props;
    return [
      {
        label: 'All sizes',
        value: Utils.ALL_PHOTOS_KEY,
        disabled: false,
      },
      ...sizes.map(size => ({
        label: generateSizeOptionLabel(size, this.props),
        value: size.key,
        disabled: false,
      })),
    ];
  }

  get resizes() {
    const {
      viewingSizeKey,
      availableSizes,
      generateSizeOptionLabel,
    } = this.props;
    return [
      {
        label: 'Resize by filtered',
        value: Utils.ALL_PHOTOS_KEY,
        disabled: false,
      },
      ...availableSizes
        .filter(({ key }) => key !== viewingSizeKey)
        .map(size => ({
          label: generateSizeOptionLabel(size, this.props),
          value: size.key,
          disabled: false,
        })),
    ];
  }

  handleChange = (value, func) => {
    let selectedValue = value;

    if (selectedValue === 'undefined') {
      selectedValue = undefined;
    }
    func(selectedValue);
  };

  render() {
    const { viewingSizeKey, onChange } = this.props;

    return (
      <div className="d-flex justify-content-between h-100">
        <div className="filter-option filter mx-auto">
          <Select
            label="Filter"
            options={this.sizes}
            value={viewingSizeKey || Utils.ALL_PHOTOS_KEY}
            inputStyleLink
            withCaret
            onChange={value => this.handleChange(value, onChange)}
          />
        </div>
      </div>
    );
  }
}

const generateSizeOptionLabel = (size, props) => {
  const { deliveryOption } = props;
  const price = QuantityHelpers.priceAtQuantityForSize(
    size,
    deliveryOption,
    true
  );
  return `${size.title} (${Currency.format(price)} ea)`;
};

PrintSizeFilter.propTypes = {
  sizes: PropTypes.arrayOf(PrintSize).isRequired,
  availableSizes: PropTypes.arrayOf(PrintSize).isRequired,
  deliveryOption: DeliveryOption.isRequired,
  viewingSizeKey: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  generateSizeOptionLabel: PropTypes.func,
  hideLabelForAllSizes: PropTypes.bool,
};

PrintSizeFilter.defaultProps = {
  viewingSizeKey: undefined,
  hideLabelForAllSizes: false,
  generateSizeOptionLabel,
};

export default PrintSizeFilter;
